import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';

const BoxWrapper = styled(Link)`
  min-height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 6px solid
    ${(props) =>
      props.active ? props.theme.mainBrandColor : props.theme.borderColor};
`;

const BoxSection = ({ title, active, to }) => (
  <div className="column  has-text-centered ">
    <BoxWrapper
      active={active}
      to={to}
      className="box is-borderless has-text-grey-dark has-text-weight-bold px-1 py-2"
    >
      <span className="is-size-6"> {title}</span>
    </BoxWrapper>
  </div>
);

const CategoryFilterOptions = () => {
  const { allSanityCategory } = useStaticQuery(graphql`
    {
      allSanityCategory {
        nodes {
          _id
          title
          slug {
            current
          }
        }
      }
    }
  `);

  return (
    <section className="section">
      <div className="container">
        <div className="columns is-centered">
          <BoxSection
            title="All"
            active={
              typeof window !== 'undefined' &&
              window.location.pathname === `/insights/`
            }
            to="/insights"
          />
          {allSanityCategory.nodes.map((item) => {
            if (!item) return null;
            const slug = item.slug.current;
            return (
              <BoxSection
                active={
                  typeof window !== 'undefined' &&
                  window.location.pathname === `/category/${slug}`
                }
                title={item.title}
                key={item._id}
                to={`/category/${slug}`}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryFilterOptions;
